export type StatusVariant = "idle" | "running" | "success" | "error";

interface StatusLineProps {
  variant: StatusVariant;
  message: string;
}

export function StatusLine({ variant, message }: StatusLineProps) {
  if (!message) return <div className="status" />;
  const cls = variant === "idle" ? "status" : `status ${variant}`;
  return <div className={cls}>{message}</div>;
}
